@if (!noPermission) {
  <div>
    <app-page-title [title]="'Garantieverlängerung abschließen'"></app-page-title>

    @if (showRechner) {
      <div class="col-12 col-lg-6 m-auto">
        <app-garantie-calculator (requestOffer)="onRequestOffer($event)"></app-garantie-calculator>
      </div>
    } @else {
      @if (!submitted) {
        <app-garantie-form-wrapper
          [premium]="premium"
          [isPremiumSchutz]="isPremiumSchutz"
          [servoAdvertiserId]="servoAdvertiserId"
          [isPublic]="isPublic"
          (submitted)="submitted = true"></app-garantie-form-wrapper>
      }
    }

    @if (submitted) {
      <div
        class="alert alert-success text-center"
        role="alert">
        Ihr Antrag wurde erfolgreich versendet! <br />
        Sie können diese Seite nun schließen.
      </div>
    }
  </div>
}

